<ng-container *ngIf="showSearch">

  <div style="display: flex; align-items: center; padding: 10px;">
    <ion-searchbar style="flex: 1;" [(ngModel)]="searchTerm" (ionInput)="onSearchChange($event)"
      placeholder="Suchen...">
    </ion-searchbar>
  </div>

  <ion-button (click)="newOrder()" fill="solid" style="margin-left: 10px;">
    <ion-icon slot="icon-only" name="add"></ion-icon>
  </ion-button>

</ng-container>

<ng-container *ngIf="!dataListFiltered || dataListFiltered.length === 0">
  <div class="empty-state">
    <ion-icon name="document-outline" class="empty-icon"></ion-icon>
    <p>Keine Aufträge gefunden</p>
  </div>
</ng-container>

<ion-list *ngIf="dataListFiltered && dataListFiltered.length > 0" class="order-list">

  <cdk-virtual-scroll-viewport
    itemSize="96"
    minBufferPx="480"
    maxBufferPx="960"
    class="order-scroll-viewport">

    <ion-item-sliding *cdkVirtualFor="let item of dataListFiltered; trackBy: trackByOrderId">

      <!-- Swipe right: open order -->
      <ion-item-options side="start">
        <ion-item-option color="success" (click)="setCurrentOrder(item)">
          <ion-icon slot="icon-only" name="create-outline"></ion-icon>
        </ion-item-option>
      </ion-item-options>

      <!-- Order Card -->
      <ion-item lines="none" class="order-item" (click)="setCurrentOrder(item)">
        <div class="order-card-content" [class.state-closed]="item.state === 1">
          <div class="order-card-header">
            <span class="order-title-text">{{ item.orderTitle | slice:0:60 }}</span>
            <div class="order-badges">
              <span
                class="delivery-status-box"
                [class.status-none]="!item.deliveryStatus || item.deliveryStatus === 'none'"
                [class.status-partial]="item.deliveryStatus === 'partial'"
                [class.status-full]="item.deliveryStatus === 'full'"
                [title]="getDeliveryStatusTitle(item.deliveryStatus)"
              ></span>
              <ion-badge [color]="item.state === 1 ? 'medium' : 'success'" class="state-badge">
                {{ item.state === 1 ? 'Abgeschlossen' : 'Offen' }}
              </ion-badge>
              <ion-badge *ngIf="item.sync === false" color="warning" class="state-badge">
                <ion-icon name="cloud-offline-outline"></ion-icon>
              </ion-badge>
              <!-- Abrechnungsstand: nur Admin, direkt in der Liste sichtbar ohne den Auftrag
                   zu öffnen. Blau = manuell als komplett markiert (keine echten 100%). -->
              <ion-badge *ngIf="isAdmin" [color]="invoicedBadgeColor(item)" class="state-badge invoiced-badge">
                {{ invoicedBadgeLabel(item) }}
              </ion-badge>
            </div>
          </div>

          <div class="order-card-customer" *ngIf="item.customerAddress?.name">
            <ion-icon name="person-outline" class="meta-icon"></ion-icon>
            <span *ngIf="!hideCustomerNames">{{ item.customerAddress.name }}</span>
            <span *ngIf="hideCustomerNames" class="customer-hidden">Kunde</span>
          </div>

          <div class="order-card-footer">
            <span class="order-meta">
              <ion-icon name="calendar-outline" class="meta-icon"></ion-icon>
              {{ item.created | date: 'dd.MM.yy' }}
            </span>
            <span class="order-meta" *ngIf="item.orderNumber">
              <ion-icon name="document-text-outline" class="meta-icon"></ion-icon>
              #{{ item.orderNumber }}
            </span>
            <span class="order-meta" *ngIf="item.karmaCartId">
              <ion-icon name="checkmark-circle-outline" class="meta-icon" style="color: #10b981"></ion-icon>
              Karma
            </span>
            <span class="order-meta" *ngIf="item.lexwareQueueCount" title="Anzahl Lexware-Übertragungen">
              <ion-icon name="cloud-upload-outline" class="meta-icon"></ion-icon>
              {{ item.lexwareQueueCount }}x
            </span>
            <span class="order-meta owner-meta" *ngIf="isAdmin && (item.owner?.email || item.owner?.username)">
              <ion-icon name="person-circle-outline" class="meta-icon"></ion-icon>
              {{ item.owner?.username || item.owner?.email }}
            </span>
            <button
              *ngIf="isAdmin && (item.invoicedPercent ?? 0) < 100"
              class="close-invoicing-btn"
              [class.active]="item.invoicingClosedManually"
              (click)="toggleInvoicingClosed(item, $event)"
              [title]="item.invoicingClosedManually ? 'Manuelle Markierung entfernen' : 'Manuell als komplett abgerechnet markieren (Rest wird nie berechnet)'">
              <ion-icon [name]="item.invoicingClosedManually ? 'lock-open-outline' : 'checkmark-done-outline'"></ion-icon>
              {{ item.invoicingClosedManually ? 'Wieder öffnen' : 'Manuell komplett' }}
            </button>
          </div>
        </div>
      </ion-item>

    </ion-item-sliding>

  </cdk-virtual-scroll-viewport>

</ion-list>
